<style>
.bg-primary {
  background-color: #2b4e8a !important;
}

.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center">
      Tambah Master RPL
      <Button
        class="btn btn-md btn-dark px-4 text-white py-2 ml-auto"
        @click="$router.go(-1)">
        Kembali
      </Button>
    </div>
    <form id="form-data" @submit.prevent="postData">
      <div id="workshop">
        <div class="card-body">
          <!-- ================ FORM DATA RPL ================ -->
          <div class="card border-0 shadow p-2">
            <div class="card-body" id="coba">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <center>
                    <img
                      :src="lihat_foto  ? lihat_foto : '/img/placeholder-image.png'"
                      style="height:220px"
                      class=" img img-responsive elevation-2 border"
                      alt="User Picture"
                    />
                    <br>                  
                    <span class="text-danger">*Format Gambar(PNG), Ukuran 500 x 850</span>

                    <div class="mt-2">
                      <div class="upload-btn-wrapper">
                        <button type="button" class="btn-upload" @click="chooseFiles()"> Unggah Flyer</button>
                        <center>
                          <input type="file"  id="fileUpload"  name="myfile" @change="uploadFlyer($event)" ref="refFlyer" />
                        </center>
                      </div>
                    </div>
                  </center>
                </div>
                <div class="form-group col-md-12">
                  <label for="nama" class="font-weight-bold">Nama RPL</label>
                  <input
                    type="text"
                    class="form-control"                    
                    id="nama"                    
                    v-model="formData.namaRpl"
                    placeholder="Masukkan Nama RPL"
                    :class="{
                      'is-invalid': $v.formData.namaRpl.$error
                    }"
                  />
                  <span class="text-danger" v-if="formData.namaRpl.length > 100">
                    *Nama RPL tidak dapat melebihi 100 karakter
                  </span>
                </div>                
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="level" class="font-weight-bold">Pilih Level</label>
                  <multiselect
                    :loading="loading"
                    label="namaLevel"
                    placeholder="Pilih Level"
                    @input="(value) => pilihLevel(value)"
                    v-model="modelLevelPeruntukan"                    
                    id="selectlevel"
                    :options="optionMasterLevel"
                    :class="{
                      'has-error': $v.modelLevelPeruntukan.$error
                    }"
                  ></multiselect>
                  <div class="text-danger" v-show="validation.level">
                    Level Harus Dipilih
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ================ END FORM DATA RPL ================ -->
          
          <!-- ================ FORM DATA WORKSHOP ================ -->
          <div class="card border-0 shadow p-2">
            <div class="card-header font-weight-bold bg-white">Workshop</div>
            <div class="card-body" id="coba">
              <div class="form-row" v-for="(input, k) in formData.sertifikasiRplMataUjiRequest" :key="`workshop-${k}`">
                  <div class="form-group col-md-11">
                    <label :for="`mata-uji-${k}`" class="font-weight-bold">Pilih Mata Uji</label>
                    <multiselect
                      :id="`mata-uji-${k}`"
                      :loading="loading"
                      label="namaMataUji"
                      placeholder="Pilih Mata Uji"
                      v-model="input.modelMultiSelect"                      
                      @input="(value) => pilihMataUji(value, k)"
                      @remove="(value) => onRemoveMataUji(value, k)"
                      :options="optionMasterMataUji"                      
                    ></multiselect>
                    <div 
                      class="text-danger" 
                      v-if="$v.formData.sertifikasiRplMataUjiRequest.$each[k].idMasterMataUji.$error">
                      Mata Uji Harus Dipilih.
                    </div>  
                  </div>
                  <div class="col-1 d-flex align-items-center mt-2">
                    <div
                      class="btn btn-sm btn-success ml-2"
                      @click="addMataUji(k)"
                      v-show="k == formData.sertifikasiRplMataUjiRequest.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                    <div
                      class="btn btn-sm btn-danger ml-2"
                      @click="removeMataUji(k)"
                      v-show="k || (!k && formData.sertifikasiRplMataUjiRequest.length > 1)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>              

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Biaya Pendaftaran</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric                      
                      class="form-control"
                      v-model="formData.biaya"
                      :options="{
                        minimumValue: '0',
                      }"
                      :class="{
                        'is-invalid': $v.formData.biaya.$error
                      }"
                    ></vue-autonumeric>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for class="font-weight-bold">Biaya Mengulang</label>
                  <div class="input-group mb-3">
                    <vue-autonumeric                      
                      v-model="formData.biayaMengulang"
                      class="form-control"
                      :options="{
                        minimumValue: '0',
                      }"
                      :class="{
                        'is-invalid': $v.formData.biayaMengulang.$error
                      }"
                    ></vue-autonumeric>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for class="font-weight-bold">Jenis Biaya Mengulang</label>
                  <select 
                    name="jenisBiayaMengulang" id="jenisBiayaMengulang" 
                    class="form-control" 
                    v-model="formData.jenisBiayaMengulang"
                    :class="{
                      'border-danger': $v.formData.jenisBiayaMengulang.$error
                    }"
                  >                    
                    <option value="">Pilih Jenis Biaya Mengulang</option>
                    <option value="mata_uji">Per Mata Uji</option>
                    <option value="hari">Per Hari</option>
                  </select>
                </div>
              </div>

              <label for="" class="font-weight-bold mb-3">Jadwal Workshop</label>
              <div class="form-row" v-for="(input, k) in formData.jadwalRplRequest" :key="`jadwal-${k}`">
                <div class="form-group col-md-5">
                  <label :for="`tanggal-${k}`" class="font-weight-bold">Tanggal Pelaksanaan</label>                  
                  <input
                    type="date"                    
                    :min="today"
                    class="form-control"                    
                    :id="`tanggal-${k}`"
                    v-model="input.tanggal"
                    placeholder="Pilih Tanggal"
                    :class="{
                      'border-danger': $v.formData.jadwalRplRequest.$each[k].tanggal.$error
                    }"
                  />                  
                </div>
                <div class="form-group col-md-3">
                  <label :for="`waktuDimulai-${k}`" class="font-weight-bold">Waktu Dimulai</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="input.waktuDimulai"
                    @click="triggerValidateTime"
                    :id="`waktuDimulai-${k}`"
                    :class="{
                      'border-danger': $v.formData.jadwalRplRequest.$each[k].waktuDimulai.$error
                    }"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label :for="`waktuBerakhir-${k}`" class="font-weight-bold">Waktu Berakhir</label>
                  <input
                    type="time"
                    class="form-control"
                    v-model="input.waktuBerakhir"
                    @click="triggerValidationExpired"
                    :min="input.waktuDimulai"
                    :id="`waktuBerakhir-${k}`"
                    :class="{
                      'border-danger': $v.formData.jadwalRplRequest.$each[k].waktuBerakhir.$error
                    }"
                  />                  
                <span class="text-danger" v-if="$v.formData.jadwalRplRequest.$each[k].waktuBerakhir.$error">
                  *Kurang dari waktu mulai
                </span>
                </div>
                <div class="col-1 d-flex align-items-center mt-3">
                  <div
                    class="btn btn-sm btn-success ml-2"
                    @click="addJadwal(k)"
                    v-show="k == formData.jadwalRplRequest.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2"
                    @click="removeJadwal(k)"
                    v-show="k || (!k && formData.jadwalRplRequest.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Kapasitas Peserta</label>
                  <div class="input-group">
                    <input 
                      type="number" 
                      min="0" 
                      class="form-control" 
                      placeholder="Masukkan Kapasitas" 
                      v-model="formData.kapasitas"
                      :class="{
                        'is-invalid': $v.formData.kapasitas.$error
                      }"
                    >
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Jenis Workshop</label>                  
                    <select 
                      name="" 
                      id="" 
                      class="form-control"
                      v-model="formData.jenisWorkshop"
                      :class="{
                        'is-invalid': $v.formData.jenisWorkshop.$error
                      }"
                    >   
                      <option value="online">Online</option>
                      <option value="offline">Offline</option>
                    </select>
                </div>
              </div>

              <div class="form-row" v-if="formData.jenisWorkshop == 'online'">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Link Workshop</label>
                  <div class="input-group mb-3">
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="Masukkan link workshop" 
                      v-model="formData.linkWorkshop"
                      :class="{
                        'is-invalid': $v.formData.linkWorkshop.$error
                      }"
                    >
                  </div>
                </div>
              </div>

              <div class="form-row" v-if="formData.jenisWorkshop == 'offline'">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Lokasi Workshop</label>
                  <div class="input-group mb-3">
                    <textarea 
                      name="lokasi" 
                      class="form-control" 
                      id="lokasi" 
                      cols="30" 
                      rows="5" 
                      placeholder="Masukkan lokasi workshop"
                      v-model="formData.lokasi"
                      :class="{
                        'is-invalid': $v.formData.lokasi.$error
                      }"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ================ END FORM DATA WORKSHOP ================ -->
          
          <!-- ================ FORM DATA TEST CENTER ================ -->
          <div class="card border-0 shadow p-2">
            <div class="card-header font-weight-bold bg-white">Test Center</div>
            <div class="card-body" id="coba">
              <div class="form-row" v-for="(input, k) in formData.sertifikasiRplMataUjiRequestTc" :key="`test-center-${k}`">
                  <div class="form-group col-md-6">
                    <label :for="`mata-uji-tc-${k}`" class="font-weight-bold">Pilih Mata Uji</label>
                    <multiselect
                      :loading="loading"
                      :id="`mata-uji-tc-${k}`"
                      label="namaMataUji"
                      placeholder="Pilih Mata Uji"
                      v-model="input.modelMultiSelect"                
                      @input="(value) => pilihMataUjiTc(value, k)"
                      @remove="(value) => onRemoveTestCenter(value, k)"
                      :options="optionMasterMataUji"
                    ></multiselect>
                    <div 
                      class="text-danger" 
                      v-if="$v.formData.sertifikasiRplMataUjiRequestTc.$each[k].idMasterMataUji.$error">
                      Mata Uji Harus Dipilih.
                    </div> 
                  </div>
                  <div class="form-group col-md-5">
                    <label for="biaya" class="font-weight-bold">Biaya Per Mata Uji</label>
                    <vue-autonumeric
                      class="form-control"
                      :options="{
                        minimumValue: '0'
                      }"
                      v-model="input.biayaMataUji"
                    ></vue-autonumeric>
                  </div>
                  <div class="col-1 d-flex align-items-center mt-2">
                    <div
                      class="btn btn-sm btn-success ml-2"
                      @click="addTestCenter(k)"
                      v-show="k == formData.sertifikasiRplMataUjiRequestTc.length - 1"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </div>
                    <div
                      class="btn btn-sm btn-danger ml-2"
                      @click="removeTestCenter(k)"
                      v-show="k || (!k && formData.sertifikasiRplMataUjiRequestTc.length > 1)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                  </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for class="font-weight-bold">Biaya Pendaftaran</label>
                  <div class="input-group">
                    <vue-autonumeric                      
                      v-model="formData.biayaTc"
                      class="form-control"
                      :options="{
                        minimumValue: '0',
                      }"
                      :class="{
                        'is-invalid': $v.formData.biayaTc.$error
                      }"
                    ></vue-autonumeric>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!-- ================ END FORM DATA TEST CENTER ================ -->

          
          <!-- ================ FORM DOKUMEN UPLOAD ================ -->
          <div class="card border-0 shadow p-2" id="divdokumen">
            <div class="card-header bg-white text-muted h4">
              Dokumen Persyaratan
            </div>
            <div class="card-body">
              <div class="form-row" v-for="(input, k) in formData.dokumenPendukungSertifikasiRplRequest" :key="`dokumen-${k}`">
                <div class="form-group col-md-6">
                  <label :for="`dokumen-${k}`" class="font-weight-bold">Pilih Dokumen</label>
                  <multiselect
                    :id="`dokumen-${k}`"
                    :loading="loading"
                    label="namaDokumen"
                    placeholder="Pilih Dokumen"
                    v-model="input.modelMultiSelect"                    
                    @input="(value) => pilihDokumenPersyaratan(value, k)"
                    @remove="(value) => onRemoveDokumenPersyaratan(value, k)"
                    :options="optionMasterDokumen"
                  ></multiselect>
                  <div 
                    class="text-danger" 
                    v-if="$v.formData.dokumenPendukungSertifikasiRplRequest.$each[k].idMasterDokumenPendukung.$error">
                    Dokumen Harus Dipilih.
                  </div> 
                </div>
                <div class="form-group col-md-5">
                  <label for="nama_dok" class="font-weight-bold">Status Dokumen</label>
                  <select 
                    class="form-control" 
                    style="height: 42px" 
                
                    v-model="input.statusRequired"
                    :class="{
                      'border-danger': $v.formData.dokumenPendukungSertifikasiRplRequest.$each[k].statusRequired.$error
                    }"
                  >
                    <option value="">Pilih Status Dokumen</option>
                    <option value="1">Wajib</option>
                    <option value="0">Tidak Wajib</option>
                  </select>                  
                </div>

                <div class="col-1 d-flex align-items-center">
                  <div
                    class="btn btn-sm btn-success ml-2 mt-2"
                    @click="addDokumenPersyaratan(k)"
                    v-show="k == formData.dokumenPendukungSertifikasiRplRequest.length - 1">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2 mt-2"
                    @click="removeDokumenPersyaratan(k)"
                    v-show="k || (!k && formData.dokumenPendukungSertifikasiRplRequest.length > 1)">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ================ End FORM DOKUMEN UPLOAD ================ -->

          <!-- ================ FORM DOKUMEN UPLOAD ================ -->
          <div class="card border-0 shadow p-2" id="divpenerbitan">
            <div class="card-header bg-white text-muted h4">
              Dokumen Persyaratan Penerbitan Sertifikat
            </div>
            <div class="card-body">
              <!-- <form> -->
              <div class="form-row" v-for="(input, k) in formData.dokumenPersyaratanSertifikat" :key="`sertifikat-${k}`">
                <div class="form-group col-md-6">
                  <label :for="`sertifikat-${k}`" class="font-weight-bold">Pilih Dokumen</label>
                  <multiselect
                    :id="`sertifikat-${k}`"
                    :loading="loading"
                    label="namaDokumen"
                    placeholder="Pilih Dokumen"
                    v-model="input.modelMultiSelect"                    
                    @input="(value) => pilihDokumenPenerbitan(value, k)"
                    @remove="(value) => onRemoveDokumenSertifikat(value, k)"
                    :options="optionMasterDokumen"
                  ></multiselect>
                  <div 
                    class="text-danger" 
                    v-if="$v.formData.dokumenPersyaratanSertifikat.$each[k].idMasterDokumen.$error">
                    Dokumen Harus Dipilih.
                  </div> 
                </div>
                <div class="form-group col-md-5">
                  <label for="nama_dok" class="font-weight-bold">Status Dokumen</label>
                  <select 
                    class="form-control" 
                    style="height: 42px" 
                    v-model="input.statusRequired"
                    :class="{
                      'border-danger': $v.formData.dokumenPersyaratanSertifikat.$each[k].statusRequired.$error
                    }"
                  >
                    <option value="">Pilih Status Dokumen</option>
                    <option value="1">Wajib</option>
                    <option value="0">Tidak Wajib</option>
                  </select>
                </div>

                <div class="col-1 d-flex align-items-center">
                  <div
                    class="btn btn-sm btn-success ml-2 mt-2"
                    @click="addDokumenSertifikat(k)"
                    v-show="k == formData.dokumenPersyaratanSertifikat.length - 1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2 mt-2"
                    @click="removeDokumenSertifikat(k)"
                    v-show="k || (!k && formData.dokumenPersyaratanSertifikat.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <!-- </form> -->
            </div>
          </div>
          <!-- ================ END FORM DOKUMEN UPLOAD ================ -->

          <!-- ================ STATUS ================ -->
          <div class="">
            <div class="card-body pl-0">
              <div class="row">
                <CCol sm="6">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div
                      class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="status"
                        id="aktif"                        
                        v-model="formData.status"
                        :value="'1'"
                      />
                      <label class="custom-control-label" for="aktif">Aktif</label>
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="status"
                        id="tidak_aktif"                      
                        v-model="formData.status"
                        :value="'0'"/>
                      <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                    </div>
                  </div>
                </CCol>
              </div>
            </div>
          </div>
          <!-- ================ END STATUS ================ -->
        </div>
        <div class="card-footer bg-white border-0 ml-auto mb-5 mr-3 pt-0">
          <Button
            class="btn btn-md btn-success float-right px-4"
            type="submit"
            color="success"
          >
            Simpan
          </Button>
        </div>
      </div>
      <!-- ================ END DATA RPL ================ -->
    </form>
  </div>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment';

import MasterRplService from "../../../services/rpl/master-rpl.service";
import LevelService from "../../../services/datamaster/level.service";
import AutoNumeric from "../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";
import { MasterDokumen } from "../../../mixins/master/MasterDokumen";
import { Level } from "../../../mixins/master/Level";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { MataUji } from "../../../mixins/master/MataUji";
import { UploadImage } from "../../../mixins/UploadImage";
import TextField from "../../../components/formcomponent/TextField";

const greaterThanZero = (value) => value > 0

const isAfterDate = (value, vm) => {  
  var start = vm.waktuDimulai.split(":");
  var end = value.split(":");
  var startDate = new Date(0, 0, 0, start[0], start[1], 0);
  var endDate = new Date(0, 0, 0, end[0], end[1], 0);        
  
  return new Date(endDate).getTime() >= new Date(startDate).getTime();
};

export default {
  name: "master-rpl-tambah",
  mixins: [
    MasterDokumen, 
    Level, 
    AlertUtils, 
    MataUji,
    UploadImage
  ],
  data() {
    return {
      today: '',
      loading: true,
      selected: 0,
      jenisBiayaSelected: 'paket',
      jenisWorkshopSelected: 'online',
      validation: {
        level: false,
        idKotaKab: false,
      },
      datakotakab: [],
      KotaKab: [],
      currentPage: 0,
      instruktur: [],
      mataUji: [],
      levelPeruntukan: [],
      modelLevelPeruntukan: [],
      option_grader: [],
      requiredMataUjiWorkshop: true,
      requiredMataUjiTc: true,
      lihat_foto : "",
      formData: {
        flyer : "",
        namaRpl: "",
        idLevel: "",
        sertifikasiRplMataUjiRequest: [
          {
            idMasterMataUji: "",            
          },
        ],
        biaya: 0,
        biayaMengulang: 0,  
        jenisBiayaMengulang: "",
        jadwalRplRequest: [
          {
            tanggal: "",
            waktuDimulai: "",
            waktuBerakhir: "",
          },
        ],        
        kapasitas: 0,
        jenisWorkshop: "online",
        linkWorkshop: '',
        lokasi: "",
        sertifikasiRplMataUjiRequestTc: [
          {
            idMasterMataUji: "",       
            biayaMataUji : 0,
          }    
        ], 
        biayaTc : 0,              
        biayaPerMataUji: 0, 
        dokumenPendukungSertifikasiRplRequest: [
          {          
            idMasterDokumenPendukung: "",                        
            statusRequired : "",            
          },
        ],
        dokumenPersyaratanSertifikat: [
          {            
            idMasterDokumen: "",
            statusRequired : "",
          },
        ],                                       
        status: "",        
      },

      year: '2020',
      month: '04',
      day: '18',
      hour: '12',
      min: '35'
    };
  },

  validations: {
    modelLevelPeruntukan: { required },
    formData: {        
      namaRpl: { required },      
      sertifikasiRplMataUjiRequest: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
        $each: {
          idMasterMataUji: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop;
            })
          }
        }
      },      
      biaya: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),        
      },
      biayaMengulang: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),        
      },  
      jenisBiayaMengulang: { 
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
      },
      jadwalRplRequest: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
        $each: {
          tanggal: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop
            }),
          },
          waktuDimulai: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop
            }),            
          },
          waktuBerakhir: {
            required: requiredIf(function() {
              return this.requiredMataUjiWorkshop
            }),          
            // isAfterDate(val, { waktuBerakhir }) {
            //   if (this.requiredMataUjiWorkshop) {
            //     return new Date(val) >= new Date(waktuBerakhir);
            //   }
            // }
          }
        }
      },      
      kapasitas: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),        
      },
      jenisWorkshop: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop
        }),
      },
      linkWorkshop: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop && this.formData.jenisWorkshop === 'online'
        })
      },
      lokasi: {
        required: requiredIf(function() {
          return this.requiredMataUjiWorkshop && this.formData.jenisWorkshop === 'offline'
        })
      },
      sertifikasiRplMataUjiRequestTc: {
        required: requiredIf(function() {
          return this.requiredMataUjiTc
        }),
        $each: {
          idMasterMataUji: {
            required: requiredIf(function() {
              return this.requiredMataUjiTc;
            })
          }
        }        
      },      
      biayaTc : {
        required: requiredIf(function() {
          return this.requiredMataUjiTc
        }),                
      },              
      biayaPerMataUji: {
        required: requiredIf(function() {
          return this.requiredMataUjiTc
        }),         
      }, 
      dokumenPendukungSertifikasiRplRequest: {
        required,
        $each: {
          idMasterDokumenPendukung: { required },
          statusRequired: { required }
        }
      },      
      dokumenPersyaratanSertifikat: {
        required,
        $each: {
          idMasterDokumen: { required },
          statusRequired: { required }
        }
      },                
      status: {
        required
      },        
    },
  },

  components: {
    VueAutonumeric,
    TextField,
  },

  watch: {
    'formData.jadwalRplRequest': {
      handler: function (after, before) {                           
        this.requiredMataUjiTc = false        
      },
      deep: true,
    }
  },

  mounted() {    
    this.today = moment().format("YYYY-MM-DD");
    this.getAllLevel();
    this.getAllMataUji();    
    this.getAllDokumen(); 
  },

  methods: {
    chooseFiles: function() {
      document.getElementById('fileUpload').click();
    },

    triggerValidationExpired(value) {
      // 
      // var reserv = new Date(this.year,this.month,this.day,this.hour,this.min)
      // var reservs = new Date(this.year,this.month,this.day,'14','15')
      // var hasil = reservs.getTime() - reserv.getTime()

      // if(hasil < 0) {
      //   // comment console console.log("GAK BOLEH")
      // } else {
      //   // comment console console.log('boleh')
      // }
      // this.$v.formData.jadwalRplRequest.waktuBerakhir.$touch();
    },

    triggerValidateTime() {
      
    },

    pilihLevel(event) {
      var vm = this;
      if (event.idLevelAnggota != null) {
        this.validation.level = false;
        this.formData.idLevel = event.idLevelAnggota;        
      } else {
        this.formData.idLevel = "";
      }
    },

    // JADWAL WORKSHOP
    addJadwal(index) {
      this.formData.jadwalRplRequest.push({
        tanggal: "",
        waktuDimulai: "",
        waktuBerakhir: "",
      });      
    },    

    removeJadwal(index) {
      this.formData.jadwalRplRequest.splice(index, 1);
    },    
    
    // MATA UJI WORKSHOP
    addMataUji(index) {      
      this.formData.sertifikasiRplMataUjiRequest.push({
        mata_uji: "",
        idMasterMataUji: "",
        biaya : "",
        biayaMengulang : "",
        jenisBiayaMengulang : "",
        namaMataUji : "",
        modelMultiSelect: [],
        invalid_mata_uji: false,
      });
    },
    
    pilihMataUji(event, k) {    
      this.requiredMataUjiTc = false
      var data = event.idMasterMataUji
      var status = 0

      for (
        let index = 0;
        index < this.formData.sertifikasiRplMataUjiRequest.length;
        index++
      ) {
        var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji;
        var idSelectMataUji = data;

        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
          status = 1
          this.formData.sertifikasiRplMataUjiRequest[k].modelMultiSelect = []       
          return false;
        } 
      }
      if(status == 0) {
        this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = data;
      } 
    },

    removeMataUji(index) {
      this.formData.sertifikasiRplMataUjiRequest.splice(index, 1);
    },

    onRemoveMataUji(value, index) {
      let status = 0;

      if(status == 1) {
        this.formData.sertifikasiRplMataUjiRequest[index] = value;
      } else {
        this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji = ""
        status = 1;
      }
    },

    // MATA UJI TEST CENTTER
    addTestCenter(index) {
      this.formData.sertifikasiRplMataUjiRequestTc.push({
        mata_uji: "",
        idMasterMataUji: "",
        biaya : "",
        biayaMengulang : "",
        jenisBiayaMengulang : "",
        namaMataUji : "",
        modelMultiSelect: [],
        biayaMataUji : 0,
        invalid_mata_uji: false,
      });      
    },

    pilihMataUjiTc(event, k) {      
      this.requiredMataUjiWorkshop = false;

      if (event.idMasterMataUji != null) {
        this.formData.sertifikasiRplMataUjiRequestTc[k].invalid_mata_uji = false;
      }

      var data = event.idMasterMataUji;
      this.formData.sertifikasiRplMataUjiRequestTc[k].namaMataUji = event.namaMataUji
      var status = 0

      for (
        let index = 0;
        index < this.formData.sertifikasiRplMataUjiRequestTc.length;
        index++
      ) {
        var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequestTc[index].idMasterMataUji;
        var idSelectMataUji = data;
        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
          status = 1
          this.formData.sertifikasiRplMataUjiRequestTc[k].modelMultiSelect = []  
          return false;
        }
      }
      if(status == 0) {
        this.formData.sertifikasiRplMataUjiRequestTc[k].idMasterMataUji = data;
        this.formData.sertifikasiRplMataUjiRequestTc[k].batasNilai = event.nilaiMinimum;
      }       
    },

    removeTestCenter(index) {
      this.formData.sertifikasiRplMataUjiRequestTc.splice(index, 1);
    },        

    onRemoveTestCenter(value, index) {
      let status = 0;

      if(status == 1) {
        this.formData.sertifikasiRplMataUjiRequestTc[index] = value;
      } else {
        this.formData.sertifikasiRplMataUjiRequestTc[index].idMasterMataUji = "";
        this.formData.sertifikasiRplMataUjiRequestTc[index].namaMataUji = "";
        this.formData.sertifikasiRplMataUjiRequestTc[index].batasNilai = "";    
        status = 1;
      }
    },

    // DOKUMEN PERSYARATAN
    addDokumenPersyaratan(index) {
      this.formData.dokumenPendukungSertifikasiRplRequest.push({
        contoh_dokumen: "",
        kode_dokumen: "",
        nama_dokumen: "",
        statusRequired : "",
        fileName: "",
        invalid_dokumen: false,
        idMasterDokumenPendukung: "",
      });
    },

    pilihDokumenPersyaratan(value, k) {
      var data = value.idMasterDokumen;
      var status = 0;
      for (let index = 0; index < this.formData.dokumenPendukungSertifikasiRplRequest.length; index++) {
        var idMasterDokumen = this.formData.dokumenPendukungSertifikasiRplRequest[index].idMasterDokumenPendukung;

        var idSelectMasterDokumen = data

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");          
          status = 1
          this.formData.dokumenPendukungSertifikasiRplRequest[k].modelMultiSelect = []  
          return false;
        }
      }  

      if(status == 0) {
        this.formData.dokumenPendukungSertifikasiRplRequest[k].idMasterDokumenPendukung = value.idMasterDokumen;
      }            
    },

    removeDokumenPersyaratan(index) {
      this.formData.dokumenPendukungSertifikasiRplRequest.splice(index, 1);
    },        

    onRemoveDokumenPersyaratan(value, index) {
        this.formData.dokumenPendukungSertifikasiRplRequest[index].idMasterDokumenPendukung = ""
    },

    // DOKUMEN SERTIFIKAT
    addDokumenSertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.push({
        idDokumenPendukung: "",
        idMasterDokumen: "",
        idMasterDokumenPendukung: "",
        statusRequired : "",
        invalid_dokumen: false,
      });
    },

    pilihDokumenPenerbitan(value, k) {      
      var data = value.idMasterDokumen;
      var status = 0
      for (
        let index = 0;
        index < this.formData.dokumenPersyaratanSertifikat.length;
        index++
      ) {
        var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
        var idSelectMasterDokumen = data;

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
          status = 1
          this.formData.dokumenPersyaratanSertifikat[k].modelMultiSelect = []
          return false;
        }
      }

      if(status == 0) {
        this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;          
      }       
    },        

    removeDokumenSertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.splice(index, 1);
    },            

    onRemoveDokumenSertifikat(value, index) {
      let status = 0;

      if(status == 1) {
        this.formData.dokumenPersyaratanSertifikat[index] = value;
      } else {
        this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen = ""
        status = 1;
      }
    },

    // POST ACTION
    postData() {      
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      } else {          
        this.insertData(this.formData);
      }      
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });      
      formData.flyer = this.lihat_foto;
      var vm = this;
      MasterRplService.postDataSertifikasiRpl(formData)
        .then((response) => {
          loader.hide();
          this.alertSuccess();         
          this.$router.push({ path : "/rpl/master-rpl" });
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError(error.response.data.message);          
        });
    },    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>